// CoreUI Pro source reference: /Users/guochunzhong/git/oss/coreui-pro/js/src/tab.js
import BaseComponent from "./base_component"
import { dispatch, targetElements } from "./dom"

export default class Tab extends BaseComponent {
  static componentName = "tab"

  constructor(element, config = {}) {
    super(element, config)
    element.setAttribute("aria-selected", element.classList.contains("active"))
    element.tabIndex = element.classList.contains("active") ? 0 : -1
    this.listen(element, "keydown", (event) => {
      if (
        event.altKey ||
        event.ctrlKey ||
        event.metaKey ||
        !["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Home", "End"].includes(event.key)
      )
        return
      const list = element.closest('[role="tablist"], .nav, .list-group')
      const tabs = this.tabs(list).filter((tab) => !tab.disabled && !tab.classList.contains("disabled"))
      const index = tabs.indexOf(element)
      const next =
        event.key === "Home"
          ? 0
          : event.key === "End"
            ? tabs.length - 1
            : (index + (["ArrowRight", "ArrowDown"].includes(event.key) ? 1 : -1) + tabs.length) % tabs.length
      event.preventDefault()
      tabs[next]?.focus({ preventScroll: true })
      if (tabs[next]) Tab.getOrCreateInstance(tabs[next]).show()
    })
  }

  show() {
    if (this.element.disabled || this.element.classList.contains("disabled")) return
    const list = this.element.closest('[role="tablist"], .nav, .list-group')
    const active = this.tabs(list).find((tab) => tab.classList.contains("active"))
    if (active === this.element || list?.dataset.coreuiTransitioning) return
    const hide = active && dispatch(active, "hide.coreui.tab", { relatedTarget: this.element }, { cancelable: true })
    const show = this.emit("show", { relatedTarget: active || null }, { cancelable: true })
    if (hide?.defaultPrevented || show.defaultPrevented) return
    if (list) list.dataset.coreuiTransitioning = "true"

    active?.classList.remove("active")
    active?.setAttribute("aria-selected", "false")
    if (active) active.tabIndex = -1
    this.toggleDropdown(active, false)
    const oldPane = active ? targetElements(active)[0] : null
    oldPane?.classList.remove("show", "active")

    this.element.classList.add("active")
    this.element.setAttribute("aria-selected", "true")
    this.element.tabIndex = 0
    this.toggleDropdown(this.element, true)
    const pane = targetElements(this.element)[0]
    pane?.classList.add("active")
    if (pane) {
      pane.offsetHeight
      pane.classList.add("show")
    }
    const complete = () => {
      if (list) delete list.dataset.coreuiTransitioning
      if (active) dispatch(active, "hidden.coreui.tab", { relatedTarget: this.element })
      this.emit("shown", { relatedTarget: active || null })
    }
    if (pane) this.afterTransition(pane, complete, pane.classList.contains("fade"))
    else complete()
  }

  tabs(list) {
    return [
      ...(list?.querySelectorAll(
        '[data-coreui-toggle="tab"], [data-coreui-toggle="pill"], [data-coreui-toggle="list"]',
      ) || []),
    ].filter((tab) => tab.closest('[role="tablist"], .nav, .list-group') === list)
  }

  dispose() {
    const list = this.element.closest('[role="tablist"], .nav, .list-group')
    if (list) delete list.dataset.coreuiTransitioning
    super.dispose()
  }

  toggleDropdown(element, open) {
    const dropdown = element?.closest(".dropdown-menu")?.parentElement
    const toggle = dropdown?.querySelector(".dropdown-toggle")
    if (!toggle) return
    toggle.classList.toggle("active", open)
    toggle.setAttribute("aria-expanded", open)
    dropdown.querySelector(".dropdown-menu")?.classList.toggle("show", open)
  }
}
